export const CompanyLogoIcon = ({ logoUrl, deniedServices }) => {
    const isLogoDenied = deniedServices.includes('logo');
    const shouldShowLogo = !isLogoDenied;

    if (!shouldShowLogo) return null;

    return (
        <img id="companyLogo" src={logoUrl} alt="C4W Logo" />
    );
};
